React = require('react')
Reflux = require('reflux')
_ = require('lodash')
SampleEvents = require('../../modules/events')
Form = require('../../modules/event-create-form')
SearchBox = require('../../modules/event-search')
Filter = require('../../modules/event-filter')
EventStore = require('../../../stores/EventStore')
EventActions = require('../../../actions/EventActions')

module.exports = React.createClass
    mixins: [Reflux.connect(EventStore, "items")]
    getInitialState: ->
        {
            items: []
        }

    removeItem: (item) ->
        index = @state.items.indexOf(item)
        @state.items.splice(index, 1)
        EventActions.update(@state.items)

    editItem: (item) ->
        items = @state.items

        items = _.map(items, (el) ->
            if (el.name == item.name) 
                return item
            else
                return el
        )

        EventActions.update(items)

    componentDidMount: ->
        EventActions.get('active')
        
    render: ->

        return (
            React.createElement("div", {"className": "section"},
                React.createElement("h1", null, "React + Reflux Examples"),
                React.createElement("div", {"className": "form-interaction-example"},
                    React.createElement(Filter, null),
                    React.createElement(SearchBox, null),
                    React.createElement(Form, {"title": "Create a Note", "items": (@state.items)}),
                    React.createElement(SampleEvents, { \
                        "title": "My Notes",  \
                        "removeItem": (@removeItem),  \
                        "editItem": (@editItem),  \
                        "items": (@state.items)})
                )
            )
        )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/pages/examples/form-interaction.cjsx
 **/